import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const Page = lazy(() => import('./organization-profile-page'));

export const OrganizationProfilePage = () => {
  return (
    <LazyRoute>
      <Page />
    </LazyRoute>
  );
};
